import _ from 'lodash'
import $ from 'jquery'
import SingleColumnStack from './single-column-stack'
import reportConstants from 'scoreboard/reports/report-constants'

/**
 * Takes an collection for formatters and return a collection that ensures the
 * execution of the formatter returns with the specified rowspan
 */
function applyRowspanToFormatters(formatters, rowspan) {
	return _.map(formatters, f => {
		return _.wrap(f, (dataFormatter, datum) => {
			return _.defaults({rowspan}, dataFormatter(datum))
		})
	})
}

/**
 * Escapsulates the Table Head element used in table.js
 */
class TableHead {

	constructor(c = [], opts = {}) {
		this.options = opts
		this._stacks = _.clone(c)
		this._rows = []

		if (_.isNil(this._stacks) || _.isEmpty(this._stacks)) {
			return
		}

		//first calculate the max depth of the header
		let maxDepth = 1
		_.each(this._stacks, col => {
			maxDepth = Math.max(maxDepth, col.depth || 1)
		})

		//create a row for each level in the breakdown up to the max depth
		for (let i=0; i<maxDepth; i++) {
			this._rows[i] = []
		}

		//then adjust the rowspans of stacks with rows less than max depth
		_.each(this._stacks, stack => {
			let rows = stack.rows()
			if (rows.length < maxDepth) {
				//adjust the cells of last row to fill the remaining space
				_.each(_.last(rows), cell => {
					cell.rowspan = maxDepth - rows.length + 1
				})
			}
		})

		//build the row structure for the table
		_.each(this._stacks, (stack, idx) => {
			let rows = stack.rows()
			_.each(rows, (stacks, rowIdx) => {
				this._rows[rowIdx] = this._rows[rowIdx].concat(stacks)
			})
		})

		if (this.options.editable) {
			//handle single selection between the stacks
			let simpleStacks = _.filter(this._stacks, c => c instanceof SingleColumnStack)
			_.each(this._stacks, col => {
				//ensure we allow enough listeners when editing
				let rowsWithTruncationIndicator = reportConstants.MAX_RECORD_SHOWING_EDIT + 1
				col.setMaxListeners(rowsWithTruncationIndicator * (rowsWithTruncationIndicator+1))
				col.on('select', (c, enabled) => {
					if (!_.isNil(c.repeatBy)) {
						//multi layout selected, don't show add for non multi layout stacks
						$(_.flatMap(simpleStacks, sc => sc.headerDomNodes()))
							.toggleClass('is-not-addable', enabled)
					}
					if (this._selected != c) {
						//we're switching stacks, deselect other stack
						if (enabled) {
							_.invoke(this._selected, 'select', false)
							this._selected = c
						} else {
							delete this._selected
						}
					} else if (!enabled) {
						delete this._selected
					}
				})
			})
		}

		//prune empty rows
		this._rows = _.filter(this._rows, r => !_.isEmpty(r))
		if (!_.isEmpty(this._rows)) {
			//mark the last cell
			_.each(this._rows, r => _.last(r).last = true)
		}
	}

	stacks(index = null) {
		return _.isFinite(index) && index > -1 ?
			_.find(this._stacks, c => c.index == index) : this._stacks
	}

	cells() {
		return this._rows
	}

	stackFormatters() {
		//simple layout, apply the cell formatters for each stack on each
		//record of data to generate the contents of the table
		return _.flatMap(this._stacks, col => col.cellFormatters())
	}

	formatByStack(data) {
		return _.map(data, (datum, dataRowIndex) => {
			return _.map(this.stackFormatters(), formatter => {
				return formatter(datum, dataRowIndex) || {}
			})
		})
	}

}

export default TableHead
TableHead.__filename__ = 'reports/common/table/table-head.js'
